<template>
    <div>
        <v-card class="rounded-lg fill-height">
            <v-divider></v-divider>
            <v-card-title>
                <v-icon>mdi-webhook</v-icon> Webhooks
            </v-card-title>
            <v-card-text>
                <p>When a meeting recording is ready or a guest logs in with an email address, the data will be sent to the URLs you provide here. The data is sent in JSON format as a POST to the URL. This can be to any URL including Zapier, make.com, etc.</p>
                <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
                <v-row>
                    <v-col cols="2">Title</v-col>
                    <v-col cols="4">URL</v-col>
                    <v-col cols="5">Rooms</v-col>
                    <v-col></v-col>
                </v-row>
                <v-divider></v-divider>
                <webhook v-for="webhook in app.webhooks" :key="webhook.ID" :webhook="webhook"></webhook>
            </v-card-text>
            <v-card-actions class="pb-4">
                <a href="#" @click="addWebhook" class="dotted-underline ml-2">Add Webhook +</a>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import { useUserStore } from '../../stores/user'
import { useAppStore } from '../../stores/app'
import { useRoomsStore } from '../../stores/rooms'
import Webhook from './Webhook.vue'

export default {
    name: 'Webhooks',
    created: function() {
        this.user = useUserStore()
        this.rooms = useRoomsStore()
        // this.rooms.loadRooms()
        this.app = useAppStore()
    },
    components: { Webhook },
    data: function() {
        return {
            user: null,
            // app: null,
            rooms: [],
            selected_rooms: [],
            webhooks: [
                // {ID: 1, post_title:'My Webhook', post_content:'https://somewhere.com'}
            ],
            webhook: [],
            loading: false,
            saving: false,
            integrations: [],
            headers: [    
                {
                    text: 'Integration',
                    align: 'start',
                    sortable: true,
                    value: 'locationId',
                },
                {
                    text: '',
                    value: 'actions',
                    align: 'right',
                    sortable: false
                }
            ],
            show_confirm_delete_dialog: false,
            delete_integration: { location: { name: '' } },
            show_connect_room_dialog: false,
            selected_room: 0,
            connecting_integration: null,
            connecting_room: false,
        }
    },
    mounted: function() {
        this.loadWebhooks()
    },
    computed: {

    },
    methods: {
        loadWebhooks() {
            this.loading = true
            this.user.app.get('meeting/webhooks')
            .then(response => {
                this.app.webhooks = response.data.webhooks
            })
            .finally(() => this.loading = false)
        },
        addWebhook() {
            console.log("add webhook")
            this.app.webhooks.push({ID:0, post_title:'', post_content:'', selected_rooms:[]})
        },
        saveWebhook() {
            console.log('save')
            // this.loading = true
            // this.user.app.post('meeting/webhooks', this.webhook)
        }
    }
}
</script>

<style>
.dotted-underline {
  text-decoration: none; /* Remove default underline */
  border-bottom: 1px dotted; /* Add a dotted underline */
}
</style>